<div class="content" *ngIf="role$ | async as role; else loading">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Role Details : {{ role.name }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#!"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item" [routerLink]="eps.role.rolePath">Role</li>
          <li class="breadcrumb-item active">Role Details</li>
        </ol>
      </nav>
    </div>

    <div
      class="d-flex my-xl-auto right-content align-items-center flex-wrap"
      *appHasPermission="{ role: ['edit'] }"
    >
      <div class="me-2 mb-2">
        <button
          (click)="openModel(assignUsersModal)"
          class="btn btn-primary"
          type="button"
          *ngIf="role.name !== 'Admin'"
        >
          Assign Users
        </button>
      </div>

      <!-- <div style="max-width: 250px; width: 50%; height: auto;" class="me-2 mb-2">
        <input type="text" [(ngModel)]="search" (input)="onSearchEmployee()" placeholder="Search employee..."
          class="form-control" />
      </div> -->
    </div>
  </div>

  <!-- <div class="d-flex justify-content-centre mb-3">
    <div style="max-width: 250px; width: 40%">
      <input type="text" [(ngModel)]="search" (input)="onSearchEmployee()" placeholder="Search employee..."
        class="form-control" />
    </div>
  </div>  -->

  <div class="row">
    <div class="card">
      <div class="card-body">
        <div class="pb-3 d-flex align-items-center justify-content-between">
          <!-- Left: Title -->
          <h3 class="mb-0">Manage Assignments</h3>

          <!-- <ng-container *ngIf="assignedEmployees.length > 0"> -->
          <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div class="me-3">
              <select
                class="form-select form-select-sm col-md-1"
                id="entries"
                [(ngModel)]="pageLimit"
                (change)="onPageLimitChange()"
              >
                <!-- <option selected disabled>Show Entries Per Page</option> -->
                <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">
                  {{ limit }}
                </option>
              </select>
            </div>
            <div class="dropdown me-3">
              <ng-select
                class="me-3"
                [items]="businesses$ | async"
                bindValue="id"
                placeholder="Select Business Entity"
                [searchable]="true"
                [clearable]="true"
                [searchFn]="customSearchFn"
                style="width: 200px"
                [(ngModel)]="businessId"
                (change)="onSearch()"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.businessName | capitalize }}
                </ng-template>
              </ng-select>
            </div>
            <div class="dropdown me-3">
              <select
                class="form-select"
                #statusSelect
                [(ngModel)]="status"
                (change)="loadAssignedTo(); setCurrentPage()"
              >
                <option value="" selected>Select Status</option>
                <option value="false">Active</option>
                <option value="true">Inactive</option>
              </select>
            </div>
            <!-- Right: Search -->
            <!-- <div style="width: 250px">
                <input
                  type="text"
                  [(ngModel)]="search"
                  (input)="onSearchEmployee()"
                  placeholder="Search employee..."
                  class="form-control"
                />
              </div> -->
            <div style="width: 250px">
              <input
                type="text"
                [(ngModel)]="search"
                (input)="onSearch()"
                placeholder="Search employee..."
                class="form-control"
              />
            </div>
          </div>
          <!-- </ng-container> -->
          <ng-template #noRecords>
            <div class="text-center">Record not available</div>
          </ng-template>
        </div>

        <div class="row">
          <div class="custom-datatable-filter table-responsive">
            <ng-container *ngIf="assignedTo$ | async as assignedTo">
              <ng-container *ngIf="assignedTo.length > 0; else noRecords">
                <table class="table datatable" *ngIf="assignedTo.length > 0">
                  <!-- <thead class="thead-light">
                    <tr>
                      <th>Name</th>
                      <th>Business Entity</th>
                      <th class="text-end">Action</th>
                    </tr>
                  </thead> -->
                  <!-- <tbody>
                    <tr *ngFor="let assignment of assignedTo$ | async"> -->
                  <!-- <ng-container
                        *ngIf="
                          assignment.user && assignment.user.email !== 'gopalswami1191gmail.com'
                        "
                      >
                        <td>
                          <div class="d-flex align-items-center">
                            <a
                              [routerLink]="[eps.hrm.employeePath, assignment.user!.id]"
                              class="avatar avatar-md"
                              data-bs-toggle="modal"
                              data-bs-target="#view_details"
                            >
                            </a> -->
                  <!-- <img
                              [src]="
                                assignment.user.picture
                                  ? apiEndpoint + assignment.user.picture
                                  : defaultImg
                              "
                              class="img-fluid rounded-circle"
                              alt="img"
                            /> -->
                  <!-- <ng-container
                              *ngIf="
                                assignment && assignment.user && assignment.user.picture;
                                else initials
                              "
                            >
                              <img
                                [src]="apiEndpoint + '/uploads/' + assignment.user.picture"
                                class="rounded-circle border border-2"
                                alt="img"
                              />
                            </ng-container>
                          </div>
                        </td>
                      </ng-container> -->

                  <!-- ✅ Use filtered data -->
                  <ng-container *ngIf="assignedEmployees.length > 0; else noRecords">
                    <table class="table datatable">
                      <thead class="thead-light">
                        <tr>
                          <th>Name</th>
                          <th>Business Entity</th>
                          <th class="text-end">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let assignment of assignedEmployees">
                          <ng-container
                            *ngIf="
                              assignment.user &&
                              assignment.business &&
                              assignment.user.email !== 'gopalswami1191gmail.com'
                            "
                          >
                            <td>
                              <div class="d-flex align-items-center">
                                <a
                                  [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                                  class="avatar avatar-md"
                                >
                                  <!-- Image / Initials -->
                                  <ng-container
                                    *ngIf="
                                      assignment.user.picture && !assignment.user.imageError;
                                      else initials
                                    "
                                  >
                                    <img
                                      [src]="apiEndpoint + '/uploads/' + assignment.user.picture"
                                      (error)="assignment.user.imageError = true"
                                      class="rounded-circle border border-2"
                                      alt="img"
                                    />
                                  </ng-container>

                                  <ng-template #initials>
                                    <span
                                      class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                                      style="width: 35px; height: 35px"
                                    >
                                      {{
                                        getInitials(
                                          assignment.user.firstName,
                                          assignment.user.lastName
                                        )
                                      }}
                                    </span>
                                  </ng-template>
                                </a>

                                <div class="ms-2">
                                  <p class="text-dark mb-0">
                                    <a [routerLink]="[eps.hrm.employeePath, assignment.user.id]">
                                      {{ assignment.user.firstName | capitalize }}
                                      {{ assignment.user.lastName | capitalize }}
                                    </a>
                                  </p>
                                  <span class="fs-12">{{
                                    assignment.user.business.businessName
                                  }}</span>
                                </div>
                              </div>
                            </td>

                            <td>
                              <!-- {{ assignment.user.business?.businessName | capitalize }} -->
                              {{ assignment.business?.businessName | capitalize }}
                            </td>

                            <td class="text-end">
                              <div class="action-icon d-inline-flex">
                                <!-- <button
                                  type="button"
                                  class="btn btn-icon-style p-1 m-1"
                                  (click)="deleteAssignment(assignment.id)"
                                  title="Delete"
                                > -->
                                <button
                                  type="button"
                                  class="btn btn-icon-style p-1 m-1"
                                  (click)="openDeleteModal(assignment.id)"
                                  title="Delete"
                                >
                                  <i class="ti ti-trash"></i>
                                </button>
                              </div>
                            </td>
                          </ng-container>
                        </tr>
                      </tbody>

                      <!-- <tfoot *ngIf="totalCount > 0">
                            <tr>
                              <td colspan="3">
                                <div
                                  class="d-flex align-items-center justify-content-between mt-2 px-2"
                                >
                                  <div>
                                    Showing {{ (currentPage - 1) * pageLimit + 1 }} to
                                    {{ pageLastRecord }} of {{ totalCount }} entries
                                  </div>

                                  <app-pagination
                                    [currentPage]="currentPage"
                                    [pageSize]="pageLimit"
                                    [totalRows]="totalCount"
                                    (pageChange)="onPageChange($event)"
                                  >
                                  </app-pagination>
                                </div>
                              </td>
                            </tr>
                          </tfoot> -->

                      <!-- <div *ngIf="totalCount > 0" class="d-flex align-items-center justify-content-between mt-2 px-2">

                  <div>
                    Showing {{ (currentPage - 1) * pageLimit + 1 }}
                    to {{ pageLastRecord }}
                    of {{ totalCount }} entries
                  </div>

                  <app-pagination [currentPage]="currentPage" [pageSize]="pageLimit" [totalRows]="totalCount"
                    (pageChange)="onPageChange($event)">
                  </app-pagination>

                </div> -->
                    </table>

                    <!-- ❗ No search result -->
                    <div *ngIf="noEmployee" class="text-center text-muted mt-3">
                      No employee found
                    </div>
                  </ng-container>

                  <!-- No records -->
                  <ng-template #noRecords>
                    <div class="text-center">Record not available</div>
                  </ng-template>
                  <!-- </tr> -->
                  <!-- </tbody> -->
                </table>
              </ng-container>
            </ng-container>
            <!-- <ng-container *ngIf="totalCount > 0"> -->
            <ng-container *ngIf="assignedEmployees.length > 0">
              <div class="d-flex align-items-center justify-content-between mt-2 px-2">
                <div>
                  Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                  {{ totalCount }} entries
                  <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to
                  {{ currentPage * pageLimit }} of {{ totalCount }} entries -->
                </div>

                <app-pagination
                  [currentPage]="currentPage"
                  [pageSize]="pageLimit"
                  [totalRows]="totalCount"
                  (pageChange)="onPageChange($event)"
                >
                </app-pagination>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assign Users Modal -->
<ng-template #assignUsersModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Assign Users</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div
    class="modal-body"
    style="padding: 0; display: flex; flex-direction: column; max-height: 70vh"
  >
    <div class="table-scroll-area" style="flex: 1; overflow-y: auto; padding: 1rem">
      <form *ngIf="role$ | async as role">
        <label *ngIf="role?.isStandard" class="form-label" for="businessIdtoAssign"
          >Assigned To</label
        >
        <!-- <ng-select
          *ngIf="role?.isStandard"
          class="me-3 w-100 mb-2"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessIdtoAssign"
        > -->
        <ng-select
          *ngIf="role?.isStandard"
          class="me-3 w-100 mb-2"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessIdtoAssign"
          (change)="onIsStandardChange()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>

        <label class="form-label" for="businessId">Assigned From</label>
        <ng-select
          class="me-3 w-100 mb-2"
          [items]="businesses$ | async"
          bindValue="id"
          placeholder="Select Business Entity"
          [searchable]="true"
          [clearable]="true"
          [searchFn]="customSearchFn"
          style="width: 200px"
          [(ngModel)]="businessId"
          (change)="onIsStandardChange()"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.businessName | capitalize }}
          </ng-template>
        </ng-select>
        <ng-container *ngIf="unassignedUsers$ | async as unassignedUsers">
          <!-- 🔍 Search Box -->
          <div class="mb-3">
            <input
              appTrimInput
              type="text"
              class="form-control"
              placeholder="Search users by name..."
              [(ngModel)]="searchText"
              name="searchText"
            />
          </div>

          <table
            *ngIf="filteredUsers(unassignedUsers).length > 0; else noRecords"
            class="table datatable"
          >
            <thead class="thead-light">
              <tr>
                <th>Select</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of filteredUsers(unassignedUsers)">
                <td>
                  <input
                    appTrimInput
                    type="checkbox"
                    [value]="user.id"
                    (change)="toggleSelection(user)"
                  />
                </td>
                <td class="d-flex">
                  <a href="javascript:void(0)" class="avatar avatar-md me-2">
                    <!-- <img
                      [src]="user.picture ? apiEndpoint + '/uploads/' + user.picture : defaultImg"
                      class="img-fluid rounded-circle"
                      alt="img"
                    /> -->
                    <ng-container *ngIf="user.picture; else initials">
                      <img
                        [src]="apiEndpoint + '/uploads/' + user.picture"
                        class="rounded-circle border border-2"
                        alt="img"
                      />
                    </ng-container>

                    <ng-template #initials>
                      <span
                        class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                        style="width: 35px; height: 35px"
                        >{{ getInitials(user.firstName, user.lastName) }}</span
                      >
                    </ng-template>
                  </a>
                  <span>
                    <!-- <a [routerLink]="[eps.hrm.employeePath, user.id]">{{
                      user.firstName | capitalize
                    }}</a> -->
                    {{ user.firstName | capitalize }} {{ user.lastName | capitalize }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>

        <ng-template #noRecords>
          <div class="text-center text-muted py-4"></div>
        </ng-template>
      </form>
    </div>

    <div class="modal-footer" style="padding: 1rem">
      <button
        type="button"
        class="btn btn-white border me-2"
        data-bs-dismiss="modal"
        (click)="onClose()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary wizard-next-btn"
        [disabled]="selectedUsers.length === 0"
        (click)="saveAssignedUsers()"
      >
        Add
      </button>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
